<template>
  <div class="this-page">
    <template>
      <toolBar add useSearch @clear="clearSearch" @open="open" @search="searchOrder"/>
    </template>
    <template>
      <el-table :data="list" :height="tableHeight" border size="small" stripe style="width: 100%">
        <el-table-column label="货柜名称" prop="name">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="260px">
          <template slot-scope="scope">

            <el-button type="text" @click="spread(scope.row.id)">统一货柜流转</el-button>
            <el-button type="text" @click="reName(scope.row.id)">重命名</el-button>
            <span style="margin-left:20px;color: #fa3534;font-size: 14px;cursor:pointer" type="text"
                  @click="deleteContainer(scope.row.id)">删除货柜</span>
          </template>
        </el-table-column>

      </el-table>
      <template>
        <el-pagination :current-page="page" :page-count="pageCount" background layout="prev, pager, next"
                       style="margin-top:20px"
                       @current-change="pageChange">
        </el-pagination>
      </template>
    </template>
    <el-dialog :visible.sync="dialogFormVisible" title="删除货柜">
      <el-form>
        <el-form-item :label-width="formLabelWidth" label="请输入确认删除">
          <el-input v-model="confirmDelete" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDel">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import toolBar from '../../components/tool-bar/index.vue'

export default {
  components: {
    toolBar
  },
  data() {
    return {
      formLabelWidth: '120px',
      dialogFormVisible: false,
      confirmDelete: '',
      confirmId: '',
      tableHeight: document.documentElement.clientHeight - 165 + 'px',
      load: {
        list: false
      },
      page: 1,
      searchValue: '',
      pageCount: 1,
      list: [],
      status: 1
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getList()
  },
  methods: {
    reName(id) {
      this.$prompt('请输入货柜名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        this.$fetch.post('Container/reName', {
          id: id,
          name: value
        }, true).then(res => {
          this.page = 1
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    spread(id) {
      this.$confirm('确定进行统一货柜流转吗', '货柜流转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('Container/transExpressProgress', {
          id: id,
        }, true).then(res => {
          this.page = 1
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    open() {
      this.$prompt('请输入货柜名称', '新增货柜', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({value}) => {
        this.$fetch.post('Container/create', {
          name: value,
        }, true).then(res => {
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },

    getList() {
      this.$fetch.post('Container/getListWithPage', {
        page: this.page,
        search: this.searchValue
      }, true).then(res => {
        this.load.list = true
        this.list = res.result
        this.pageCount = res.page
      })
    },
    pageChange(e) {
      this.page = e
      this.getList()
    },
    searchOrder(e) {
      if (!e) {
        this.$message({
          type: 'info',
          message: '当前没有搜索任何信息'
        });
        return false
      }
      this.searchValue = e
      this.page = 1
      this.getList()

    },
    clearSearch() {
      console.log('清空搜索')
      this.searchValue = ''
      this.page = 1
      this.getList()
    },
    confirmDel() {
      if (this.confirmDelete == '确认删除') {
        this.$fetch.post('Container/delete', {
          id: this.confirmId,
        }, true).then(res => {
          this.page = 1
          this.dialogFormVisible = false
          this.getList()
        })
      } else {
        this.$message('请输入确认删除');
      }
    },
    deleteContainer(id) {
      this.confirmId = id
      this.confirmDelete = ''
      this.dialogFormVisible = true
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 10px;
  background-color: #FFFFFF;
}
</style>
